import {RentalExtensionQuotaTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function rentalExtensionQuotaTypeNameFilter(type: RentalExtensionQuotaTypeEnum): string {
  switch (type) {
    case RentalExtensionQuotaTypeEnum.Standard: return i18n.t(LF.Standard) as string;
    case RentalExtensionQuotaTypeEnum.Discounted: return i18n.t(LF.Promotional) as string;
  }
}
